export class AppConfig {
    StripePublicApiKey: string;
    MediaLocationUrl: string;

    constructor(obj?: any) {
      this.StripePublicApiKey = obj && obj.StripePublicApiKey || '';
      this.MediaLocationUrl = obj && obj.MediaLocationUrl || '';
    }
}
